export const businessInfo = {
  name: "Joe's Appliance Installs",
  tagline: "Premium Integrated Appliance Installation",
  phone: "604-377-6407",
  email: "joe@joesapplianceinstalls.ca",
  serviceArea: "Greater Vancouver and Fraser Valley",
  experience: "11 years industry experience",
  gst: "GST #74591 7625 RT0001",
  insurance: "$5M Commercial Liability Insurance",
  worksafe: "WorkSafeBC Covered",
  instagram: "https://www.instagram.com/joesapplianceinstalls",
  facebook: "https://www.facebook.com/share/19vWdDsrah/"
};

export const services = [
  {
    id: 1,
    category: "Premium Integrated",
    description: "Sub-Zero, Gaggenau, Wolf",
    priceRange: "$650 - $950",
    brands: ["Sub-Zero", "Wolf", "Gaggenau"],
    features: [
      "Precision panel integration",
      "Custom trim installation",
      "Full electrical and plumbing connection",
      "Final calibration and testing"
    ]
  },
  {
    id: 2,
    category: "Mid-Range Integrated",
    description: "Miele, Thermador, Bosch, Liebherr",
    priceRange: "$400 - $650",
    brands: ["Miele", "Thermador", "Bosch", "Liebherr"],
    features: [
      "Professional installation",
      "Panel and trim fitting",
      "Connection and testing",
      "Warranty compliance"
    ]
  },
  {
    id: 3,
    category: "Standard Installation",
    description: "Quality appliance installation",
    priceRange: "$150 - $250",
    brands: ["All major brands"],
    features: [
      "Expert installation",
      "Proper connections",
      "Function testing",
      "Clean workspace"
    ]
  }
];

export const aboutContent = {
  owner: "Joe Pauloski",
  story: "Joe Pauloski is a Surrey-based installer with 11 years in the appliance industry — 7 years specializing in premium integrated installation. He built Joe's Appliance Installs on a simple principle: every install is treated like it's going in his own home. Serving Greater Vancouver's luxury residential and multi-residential market.",
  credentials: [
    "$5M Commercial Liability Insurance",
    "WorkSafeBC Covered",
    "GST #74591 7625 RT0001",
    "11 Years Industry Experience",
    "4 Years Appliance Delivery",
    "7 Years Specialized Installation"
  ],
  values: [
    {
      title: "Precision First",
      description: "High-end appliances demand exact installation. Every measurement, every connection, every detail matters."
    },
    {
      title: "Premium Expertise",
      description: "Specialized experience with Sub-Zero, Wolf, Gaggenau, Miele, Thermador, Bosch, and Liebherr integrated systems."
    },
    {
      title: "Your Investment Protected",
      description: "Fully insured and WorkSafeBC covered. Your premium appliances are in safe, professional hands."
    }
  ]
};

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_wonderful-joliot-4/artifacts/t8drjx30_60d3ed5d-167d-45ee-8cd3-625590ee8678-1_all_34955.jpg",
    alt: "Premium kitchen installation with integrated appliances"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_7682f6e8-f0a9-4fc2-b080-0d5340366b32/artifacts/03k9xo02_1000029533.jpg",
    alt: "Modern kitchen with integrated Sub-Zero refrigerator"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_7682f6e8-f0a9-4fc2-b080-0d5340366b32/artifacts/i8qyyrwa_1000029531.jpg",
    alt: "High-end appliance installation detail"
  }
];

export const heroBannerImage = "https://customer-assets.emergentagent.com/job_wonderful-joliot-4/artifacts/t8drjx30_60d3ed5d-167d-45ee-8cd3-625590ee8678-1_all_34955.jpg";

export const instagramQRCode = "https://customer-assets.emergentagent.com/job_wonderful-joliot-4/artifacts/ldrh5uyw_1000030234.png";

export const logoUrl = "https://customer-assets.emergentagent.com/job_wonderful-joliot-4/artifacts/4jydftkz_1000030275.png";

// Mock form submission handler
export const submitQuoteRequest = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Quote request received! Joe will contact you within 24 hours." });
    }, 1000);
  });
};
